import { Power3, TweenMax } from 'gsap';
import Core from '../../../Core/Core';
import Tile from '../../../Tiles/Tile';
import { createOutlineText } from '../../../Utils/Utils';
import { Animation } from '../../Animations/Animation';

export class MovesCounter extends PIXI.Container {
    private possibleMovesAnimation: Animation;
    private readonly possibleMovesCount: PIXI.Text;
    private readonly possibleMovesText: PIXI.Text;
    private readonly isPortrait: boolean;

    constructor(width: number, height: number, isPortrait: boolean) {
        super();

        const movesCountWidth = isPortrait ? width * 0.4 : width * 0.65;
        const movesCountHeight = isPortrait ? height * 0.5 : height * 0.3;
        const possibleMovesCount = (this.possibleMovesCount = createOutlineText(
            '20',
            new PIXI.Rectangle(0, 0, movesCountWidth, movesCountHeight),
            'Baloo',
            isPortrait ? 20 : 30,
            10
        ));

        const movesTextWidth = isPortrait ? width * 0.5 : width * 0.75;
        const movesTextHeight = isPortrait ? height * 0.5 : height * 0.2;
        const possibleMovesText = (this.possibleMovesText = createOutlineText(
            Core.local.getText('possiblemoves'),
            new PIXI.Rectangle(0, 0, movesTextWidth, movesTextHeight),
            'Baloo',
            18,
            18
        ));
        this.isPortrait = isPortrait;

        this.addChild(possibleMovesText, possibleMovesCount);
    }

    public showPossibleMoves(available: Tile[]) {
        const { possibleMovesText, possibleMovesCount, possibleMovesAnimation } = this;
        const availableMatches = available ? available.length / 2 : 0;
        possibleMovesCount.text = availableMatches.toString();

        if (this.isPortrait) {
            possibleMovesCount.x =
                possibleMovesText.x + (possibleMovesText.width + possibleMovesCount.width) / 1.9;
        } else {
            possibleMovesCount.y = possibleMovesText.y + possibleMovesText.height * 0.8;
        }

        if (possibleMovesAnimation) {
            possibleMovesAnimation.seek(0);
            possibleMovesAnimation.kill();
        }
        const animation = new Animation({});
        const stuck = availableMatches === 0;
        if (!stuck) {
            animation.add(
                TweenMax.fromTo(
                    possibleMovesCount,
                    0.2,
                    { tint: 0xffffff },
                    {
                        tint: 0xffde67,
                        ease: Power3.easeInOut,
                        repeat: 1,
                        yoyo: true,
                    }
                )
            );
        } else {
            animation.add(
                TweenMax.to([possibleMovesCount, possibleMovesText], 0.3, {
                    tint: 0xff8533,
                    ease: Power3.easeInOut,
                    repeat: 8,
                    yoyo: true,
                })
            );
        }

        this.possibleMovesAnimation = animation;
        animation.play();
    }
}
